<h2>Property Bedroom Details</h2>
<ag-grid-angular 
	style="width: auto; height: auto; margin: 20px 0px;" 
	class="ag-theme-balham"
	[gridOptions]="gridOptions"
	[rowData]="propertyDevelopments" 
	(gridReady)="onGridReady($event)"
	(firstDataRendered)="onFirstDataRendered($event)"
	(rowGroupOpened)="onRowGroupOpened($event)"
>
</ag-grid-angular>